import React from "react";

export const LoginPage = () => {
  return <div>loginPage</div>;
};
